import React from 'react';
import _ from 'underscore';
import { translate } from 'react-i18next';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';

import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import LoadInline from 'modules/loading/LoadInline.js';
import {colors, spacings} from 'style';
import {getCompetitionProgressBars} from './tools.js';
import defaultChallengeImage from 'img/default-challenge-image.jpg';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    segment: {
        border: 'none',
        boxShadow: 'none',
    },
    cards: {
        justifyContent: 'center'
    },
    card: {
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    message: {
        padding: '.78571429em 1.5em .78571429em',
        fontSize: '1rem',
        lineHeight: '1em'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    categoryBadge: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        width: '40px',
        height: '40px',
        border: '2px solid #fff',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: colors.themeDarkGrey,
        fontSize: '30px',
        textAlign: 'center',
        lineHeight: '38px',
    },
    iconHeader: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        minHeight:'62px', 
        padding:'5px 60px 0px 16px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    challengeMenu: {
        position: 'absolute',
        top: '14px',
        right: '10px',
        fontSize: '22px',
        backgroundColor: 'transparent',
        color: '#fff',
        border: '0px solid #fff',
        boxShadow:'none',
    },
    imageBanner: {
        height:'160px', 
        width:'100%',
        backgroundSize:'cover',
        backgroundPositionY: 'center',
    },
    points: {
        fontSize: '0.9em',
        fontWeight: 'normal',
    },
    starIcon: {
        color: colors.pointsYellow,
    },
    header: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontSize: '1em',
        color:'#fff', 
    },
    duration: {
        color:'#fff', 
    },
    type: {
        color:'#fff', 
    },
    cardContent: {
        padding: spacings.tiny,
        position: 'relative',
        textAlign: 'center',
        backgroundColor: colors.themeBlue,
    },
    skipLeftIcon: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        position: 'absolute',
        left: '10px',
        top: '50%',
        marginTop: '-20px',
    },
    skipRightIcon: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        position: 'absolute',
        right: '10px',
        top: '50%',
        marginTop: '-20px',
    },
    addNewGoalIcon: {
        backgroundColor: '#fff',
        color: colors.themeBlue,
        border: 'none',
        boxShadow: 'none',
    },
    addNewGoalBanner: {
        textAlign:'center', 
        lineHeight: '160px',
    },
    levelText: {
        fontWeight: 'light',
        fontSize: '0.9em',
    },
    progressBar: {
        backgroundColor: '#fff',
    },
    yellowLabel: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '200px',
        height: '31px',
        position: 'absolute',
        top: '-16px',
        left: '50%',
        marginLeft: '-100px',
        backgroundColor: colors.pointsYellow,
        padding: '4px',
        border: '1px solid #fff',
        borderRadius: '2px',
        textAlign: 'center',
    },
    progressbarWrapper: {
        paddingTop: '4px',
        paddingBottom: '4px',
    },
    bottomContent: {
        position: 'absolute',
        bottom: '0px',
        left: '0px',
        width: '100%',
    },
    spacer: {
        height:'197px', 
    }
};

const Competitions = ({t,
                     competitions, 
                     onLaunchCompetition, 
                     onLaunchCompetitionActivities,
                     formatDuration, 
                     getChallengeImageUrl,
                     getCompetitionYellowLabel}) => (
    <div style={style.content}>
    {(competitions.length>0) && 
        <Segment style={style.segment}>
            <Card.Group style={style.cards}>
                {competitions.map((item)=>(
                        <Card key={item.id} style={style.card} onClick={()=>onLaunchCompetitionActivities(item)}>
                            <div style={style.iconHeader}>

                                <div style={{height:'15px'}} />

                                {Utils.deref(item, 'season.competition.title')}
                                <div>
                                    <Icon style={style.challengeMenu} className='icon-settings3' onClick={(e)=>onLaunchCompetition(e, item)}></Icon> 
                                </div>
                                {getCompetitionProgressBars(item.season.userRecord, item.season.seasonMilestone, t).map(progressbar => 
                                    <div key={progressbar.type} style={style.progressbarWrapper}>
                                        <ProgressBar style={style.progressBar} value={progressbar.percent} total={100} borderWidth={'0'} />
                                        <div>{progressbar.label}</div>
                                    </div>
                                )}
                            </div>
                            <div style={style.yellowLabel}>{getCompetitionYellowLabel(item)}</div>

                            <div style={style.spacer} />

                            <div style={style.bottomContent}>
                                <div style={{...style.imageBanner, backgroundImage:Utils.url(Utils.deref(item, 'season.competition.banner.url') || defaultChallengeImage)}}/>


                                <div style={style.cardContent}>
                                    <div style={style.header}>
                                        {Utils.deref(item, 'season.competition.buttonLabel')}
                                        <br/>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))
                }
                {/*hack to force left alignment of last row*/}
                {_.times(10, i=>(<Card key={i} style={{...style.card, ...style.pseudoCard}} />))}
            </Card.Group>
        </Segment>
    }
    </div>
);
export default translate(['challenges', 'categories'])(Competitions);



// WEBPACK FOOTER //
// ./src/modules/challenges/Competitions.js